export default "__VITE_ASSET__B3QkpMmn__"